module.exports = __webpack_public_path__ + "static/media/lending-cove-homepage.b40e03cb.jpg";